import { ReactComponent as SubmenuOpen } from "assets/images/side-menu/submenu-open.svg";
import Badge from "components/Badge";
import { getSupportsCoachApproach } from "modules/facility-options/facilityOptionsServices";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const NavbarItem = ({ navItem, setActiveItem, activeItem }) => {
  const isActive = activeItem.link === navItem.link;
  const [showSubmenu, setShowSubmenu] = useState(false);

  const onClickLink = () => {
    if (navItem.link === "#") {
      setShowSubmenu((p) => !p);
    } else {
      setActiveItem(navItem);
    }
  };

  return (
    <>
      <Link
        className={isActive ? "navbar-item active" : "navbar-item"}
        to={navItem.link}
        onClick={onClickLink}
      >
        {isActive ? <div className="navbar-item active-corner" /> : null}
        {isActive ? navItem.activeIcon : navItem.inactiveIcon}
        <h3 className={isActive ? "navbar-item h3-active" : "navbar-item h3"}>
          {navItem.name}
          {navItem.badge ? <Badge number={navItem.badge} className="navbar-item-badge" /> : null}
        </h3>
        {navItem.submenu ? (
          <div className={`navbar-item-right-icon ${showSubmenu ? `` : ` collapsed`}`}>
            <SubmenuOpen width={24} height={24} />
          </div>
        ) : null}
      </Link>
      {showSubmenu && navItem.submenu ? (
        <div className="navbar-submenu">
          {navItem.submenu.map((item, i) => (
            <NavbarItem
              key={i}
              navItem={item}
              setActiveItem={setActiveItem}
              activeItem={activeItem}
            />
          ))}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default NavbarItem;
